// extracted by mini-css-extract-plugin
export var sectionbanner = "banner-module--sectionbanner--pLRk7";
export var img = "banner-module--img--isovN";
export var container = "banner-module--container--rdaVj";
export var title = "banner-module--title--WOOq2";
export var subTitle = "banner-module--subTitle--+-InF";
export var btn = "banner-module--btn--gQFbY";
export var br1 = "banner-module--br1--JTqVs";
export var br2 = "banner-module--br2--SHvtD";